import { render, staticRenderFns } from "./MetricCard.vue?vue&type=template&id=b0e4e590&scoped=true&lang=pug"
import script from "./MetricCard.vue?vue&type=script&lang=js"
export * from "./MetricCard.vue?vue&type=script&lang=js"
import style0 from "./MetricCard.vue?vue&type=style&index=0&id=b0e4e590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e4e590",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VIcon,VTooltip})
